(function () {
  var header = document.querySelector('.oddit-header');
  if (!header) return;

  var megaMenu = header.querySelector('[data-mega-menu]');
  var megaOverlay = header.querySelector('[data-mega-menu-overlay]');
  var megaTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
  var mobileMenu = header.querySelector('[data-mobile-menu]');
  var mobileMenuToggle = header.querySelector('[data-mobile-menu-toggle]');
  var mobileMenuClose = header.querySelector('[data-mobile-menu-close]');
  var mobileMenuFooter = header.querySelector('[data-mobile-menu-footer]');
  var mobileMenuRoot = header.querySelector('[data-mobile-menu-root]');
  var mobileSubmenuOpeners = header.querySelectorAll('[data-mobile-submenu-open]');
  var mobileSubmenuBacks = header.querySelectorAll('[data-mobile-submenu-back]');
  var activeMobileSubmenu = null;

  var activeTrigger = null;
  var megaCloseTimer = null;

  function isHoverPointer(e) {
    return e.pointerType === 'mouse' || e.pointerType === 'pen';
  }

  function showMegaPanel(label) {
    if (!megaMenu) return;
    var panels = megaMenu.querySelectorAll('[data-mega-menu-label]');
    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      if (panel.getAttribute('data-mega-menu-label') === label) {
        panel.style.display = '';
      } else {
        panel.style.display = 'none';
      }
    }
  }

  function openMegaMenu(label) {
    if (!megaMenu) return;
    clearTimeout(megaCloseTimer);
    showMegaPanel(label);
    megaMenu.classList.add('is-open');
    megaMenu.setAttribute('aria-hidden', 'false');
    if (megaOverlay) {
      megaOverlay.classList.add('is-visible');
      megaOverlay.setAttribute('aria-hidden', 'false');
    }
  }

  function closeMegaMenu() {
    if (!megaMenu) return;
    megaMenu.classList.remove('is-open');
    megaMenu.setAttribute('aria-hidden', 'true');
    if (megaOverlay) {
      megaOverlay.classList.remove('is-visible');
      megaOverlay.setAttribute('aria-hidden', 'true');
    }
    for (var i = 0; i < megaTriggers.length; i++) {
      megaTriggers[i].setAttribute('aria-expanded', 'false');
    }
    activeTrigger = null;
  }

  function scheduleCloseMegaMenu() {
    clearTimeout(megaCloseTimer);
    megaCloseTimer = setTimeout(function () {
      closeMegaMenu();
    }, 180);
  }

  function openMegaMenuFor(trigger) {
    clearTimeout(megaCloseTimer);
    var label = trigger.getAttribute('data-mega-menu-label');
    for (var i = 0; i < megaTriggers.length; i++) {
      megaTriggers[i].setAttribute('aria-expanded', 'false');
    }
    trigger.setAttribute('aria-expanded', 'true');
    activeTrigger = trigger;
    openMegaMenu(label);
  }

  /* Mega menu — hover + click */
  for (var t = 0; t < megaTriggers.length; t++) {
    (function (trigger) {
      var wrapper = trigger.closest('.oddit-header__nav-item') || trigger.parentElement;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          closeMegaMenu();
        } else {
          openMegaMenuFor(trigger);
        }
      });

      if (wrapper) {
        wrapper.addEventListener('pointerenter', function (e) {
          if (!isHoverPointer(e)) return;
          openMegaMenuFor(trigger);
        });
        wrapper.addEventListener('pointerleave', function (e) {
          if (!isHoverPointer(e)) return;
          scheduleCloseMegaMenu();
        });
      }
    })(megaTriggers[t]);
  }

  if (megaMenu) {
    megaMenu.addEventListener('pointerenter', function (e) {
      if (!isHoverPointer(e)) return;
      clearTimeout(megaCloseTimer);
    });
    megaMenu.addEventListener('pointerleave', function (e) {
      if (!isHoverPointer(e)) return;
      scheduleCloseMegaMenu();
    });
  }

  if (megaOverlay) {
    megaOverlay.addEventListener('click', closeMegaMenu);
  }

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (megaMenu && megaMenu.classList.contains('is-open')) {
        closeMegaMenu();
      }
      if (mobileMenu && mobileMenu.classList.contains('is-open')) {
        if (activeMobileSubmenu) {
          closeMobileSubmenu();
        } else {
          closeMobileMenu();
        }
      }
    }
  });

  /* Mobile menu footer — hide top shadow once scrolled to the bottom */
  function updateMobileFooterShadow() {
    if (!mobileMenuRoot || !mobileMenuFooter) return;
    var atBottom =
      mobileMenuRoot.scrollTop + mobileMenuRoot.clientHeight >=
      mobileMenuRoot.scrollHeight - 1;
    mobileMenuFooter.classList.toggle('is-at-bottom', atBottom);
  }

  if (mobileMenuRoot) {
    mobileMenuRoot.addEventListener('scroll', updateMobileFooterShadow, { passive: true });
    window.addEventListener('resize', updateMobileFooterShadow);
  }

  /* Mobile submenu drill-down (level 1 panels) */
  function resetMobileSubmenus() {
    var panels = header.querySelectorAll('[data-mobile-submenu]');
    for (var i = 0; i < panels.length; i++) {
      panels[i].classList.remove('is-active');
      panels[i].setAttribute('aria-hidden', 'true');
    }
    for (var j = 0; j < mobileSubmenuOpeners.length; j++) {
      mobileSubmenuOpeners[j].setAttribute('aria-expanded', 'false');
    }
    if (mobileMenuRoot) mobileMenuRoot.removeAttribute('aria-hidden');
    activeMobileSubmenu = null;
  }

  function openMobileSubmenu(name, opener) {
    var panel = header.querySelector('[data-mobile-submenu="' + name + '"]');
    if (!panel) return;
    panel.classList.add('is-active');
    panel.setAttribute('aria-hidden', 'false');
    if (mobileMenuRoot) mobileMenuRoot.setAttribute('aria-hidden', 'true');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    activeMobileSubmenu = { panel: panel, opener: opener };
    var scroll = panel.querySelector('.oddit-header__mobile-menu-subpanel-scroll');
    if (scroll) scroll.scrollTop = 0;
    var back = panel.querySelector('[data-mobile-submenu-back]');
    if (back) back.focus({ preventScroll: true });
  }

  function closeMobileSubmenu() {
    if (!activeMobileSubmenu) return;
    var current = activeMobileSubmenu;
    current.panel.classList.remove('is-active');
    current.panel.setAttribute('aria-hidden', 'true');
    if (mobileMenuRoot) mobileMenuRoot.removeAttribute('aria-hidden');
    if (current.opener) {
      current.opener.setAttribute('aria-expanded', 'false');
      current.opener.focus({ preventScroll: true });
    }
    activeMobileSubmenu = null;
  }

  for (var so = 0; so < mobileSubmenuOpeners.length; so++) {
    (function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openMobileSubmenu(btn.getAttribute('data-mobile-submenu-open'), btn);
      });
    })(mobileSubmenuOpeners[so]);
  }

  for (var sb = 0; sb < mobileSubmenuBacks.length; sb++) {
    mobileSubmenuBacks[sb].addEventListener('click', closeMobileSubmenu);
  }

  /* Mobile menu */
  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (mobileMenuToggle) {
      mobileMenuToggle.setAttribute('aria-expanded', 'true');
    }
    document.body.classList.add('oddit-header-menu-open');
    resetMobileSubmenus();
    updateMobileFooterShadow();
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (mobileMenuToggle) {
      mobileMenuToggle.setAttribute('aria-expanded', 'false');
    }
    document.body.classList.remove('oddit-header-menu-open');
    resetMobileSubmenus();
  }

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', openMobileMenu);
  }
  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMobileMenu);
  }

  /* Cart integration — open drawer via window.OdditCartDrawer */
  var cartToggles = header.querySelectorAll('[data-cart-toggle]');
  for (var i = 0; i < cartToggles.length; i++) {
    cartToggles[i].addEventListener('click', function () {
      if (window.OdditCartDrawer) {
        window.OdditCartDrawer.open();
      }
    });
  }

  /* Search integration — open drawer via window.OdditSearchDrawer */
  var searchToggles = header.querySelectorAll('[data-search-toggle]');
  for (var s = 0; s < searchToggles.length; s++) {
    (function (toggle) {
      toggle.addEventListener('click', function () {
        if (window.OdditSearchDrawer) {
          window.OdditSearchDrawer.open();
        }
      });
      /* Keyboard support for div-based search toggle with role="button" */
      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (window.OdditSearchDrawer) {
            window.OdditSearchDrawer.open();
          }
        }
      });
    })(searchToggles[s]);
  }

  /* Mobile menu search field — hand off to the drawer rather than search in place.
     Blur first: focusing the drawer's input while this one still holds focus
     flashes a second caret on mobile Safari. */
  var mobileSearchInput = header.querySelector('[data-mobile-search-input]');
  if (mobileSearchInput) {
    var handoffToSearchDrawer = function (e) {
      if (e) e.preventDefault();
      if (!window.OdditSearchDrawer) return;
      var typed = mobileSearchInput.value || '';
      mobileSearchInput.blur();
      mobileSearchInput.value = '';
      closeMobileMenu();
      if (typeof window.OdditSearchDrawer.openWithQuery === 'function') {
        window.OdditSearchDrawer.openWithQuery(typed);
      } else {
        window.OdditSearchDrawer.open();
      }
    };
    mobileSearchInput.addEventListener('focus', handoffToSearchDrawer);
    mobileSearchInput.addEventListener('click', handoffToSearchDrawer);
  }

  /* Cart count badge — live update via cart:updated */
  document.addEventListener('cart:updated', function (e) {
    if (!e.detail || !e.detail.cart) return;
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      badges[i].classList.toggle('is-visible', cart.item_count > 0);
    }
  });
})();
